import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userDetailsAtom, userPridAtom } from "store/atoms/commonAtom";

export default function ChatAssistantNoAccess() {
    const [splashHtml, setSpashHtml] = useState('')
    const userPrid = useRecoilValue(userPridAtom);
    const userDetails = useRecoilValue(userDetailsAtom);
    const [htmlLoaded, setHtmlLoaded] = useState(true);

    useEffect(() => {
        const htmlPath = "/brandAssistantNoAccess.html";
        fetch(htmlPath)
                .then((res) => res.text())
                .then((html) => {
                    setSpashHtml(html);
                    setHtmlLoaded(false);
                })
                .catch((err) => {
                    console.error("Failed to load HTML file:", err);
                    setHtmlLoaded(false);
                })
    }, []);

    useEffect(()=>{
        const handlePostMessage = (e) => {
            const { type, action } = e.data;
            if(type === 'aboutPostMessage'){
                switch(action){
                    case "get_started_click":
                        break;
                    case "request_access_click":
                        window.open(
                            'https://forms.cloud.microsoft/e/6DgdwFTDa8',
                            '_blank',
                            'noopener,noreferrer'
                        ); break;
                }   
            }
        }

        window.addEventListener('message', handlePostMessage)

        return () => window.removeEventListener("message", handlePostMessage);

    },[])

    return (
        <>
        {htmlLoaded ? (
            <div className="flex items-center justify-center h-screen">
                <div className="flex flex-col items-center space-y-4">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#830051]"></div>
                    <span className="text-white-600 text-lg dark:text-gray-400">Loading...</span>
                </div>
            </div>
        ) : (
            <div dangerouslySetInnerHTML={{ __html: splashHtml }} />
        )}
        </>
    );
}